import {Injectable} from '@angular/core';
import {ModalSettingsModel} from '../../../models/modal.model';
import {ModalService} from '../../../services/modal/modal.service';
import {AlertService} from '../../../services/notify/alert.service';
import {HelpersService} from '../../../services/helpers.service';
import {MemberModel} from '../../../models/user.model';
import {AuthService} from '../../../services/api/auth.service';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class UserControlService {

    constructor(
        protected modalService: ModalService,
        protected authControl: AuthService,
        protected alertService: AlertService,
        protected helper: HelpersService,
        protected translate: TranslateService,
    ) {
    }

    deleteUserFromProject(userGuid: string): Promise<boolean> {
        return new Promise(resolve => {
            this.authControl.deleteUserFromProject(userGuid).subscribe({
                next: res => {
                    this.alertService.setAlert(res.message, 'green');
                    resolve(true);
                }, error: error => {
                    this.alertService.setAlert(error.message, 'blue');
                    resolve(false);
                },
            });
        });
    }

    updateProjectRights(user: MemberModel, rights: string): Promise<boolean> {
        return new Promise(resolve => {
            if (rights === 'proj_admin') {
                let modalSettings: ModalSettingsModel;
                modalSettings = {
                    modalHeader: this.translate.instant('CONFIRM.HEADERS.ADMIN'),
                    buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.SET'),
                    buttonClose: this.translate.instant('CONFIRM.BUTTONS.CANCEL'),
                };
                if (!user.project_setting.is_project_admin) {
                    modalSettings.modalBody = this.translate.instant('CONFIRM.TEXT.SET_ADMIN', {user: this.helper.fullName(user)});
                } else {
                    modalSettings.modalBody = this.translate.instant('CONFIRM.TEXT.REMOVE_ADMIN', {user: this.helper.fullName(user)});
                }
                const modal = this.modalService.createFromSettings(modalSettings);
                modal.result.then(data => {
                    if (data) {
                        resolve(this.updateRights(user, rights));
                    }
                }).catch(() => {
                    return;
                });
            } else {
                resolve(this.updateRights(user, rights));
            }
        });
    }

    updateRights(user: MemberModel, rights: string): Promise<boolean> {
        return new Promise(resolve => {
            this.authControl.changeUserObservation(user.guid, rights).subscribe({
                next: res => {
                    this.alertService.setAlert(res.message, 'green');
                    resolve(true);
                }, error: error => {
                    this.alertService.setAlert(error.message, 'blue');
                    resolve(false);
                },
            });
        });
    }

    inviteUserInProject(data: { email: string; observ: string; position: string; }): Promise<boolean> {
        return new Promise(resolve => {
            this.helper.setInvite(data).then(() => {
                resolve(true);
            }).catch(() => {
                resolve(false);
            });
        });
    }

    giveCryptoToUser(currentUserGuid: string): Promise<boolean> {
        return new Promise((resolve) => {
            let modalSettings: ModalSettingsModel;
            modalSettings = {
                modalHeader: this.translate.instant('CONFIRM.HEADERS.CRYPTO'),
                buttonSubmit: this.translate.instant('CONFIRM.BUTTONS.YES'),
                buttonClose: this.translate.instant('CONFIRM.BUTTONS.NO'),
            };
            const modal = this.modalService.createFromSettings(modalSettings);
            modal.result.then(data => {
                if (data) {
                    const query = {
                        guid: currentUserGuid,
                        provider: 'crypto_pro',
                    };
                    this.authControl.giveToUserProjectCrypto(query).subscribe({
                        next: res => {
                            this.alertService.setAlert(res.message, 'green');
                            resolve(true);
                        }, error: error => {
                            this.alertService.setAlert(error.message, 'blue');
                            resolve(false);
                        },
                    });
                }
            }).catch(() => {
                return;
            });
        });
    }
}
